import { render, staticRenderFns } from "./TheAppHeader.vue?vue&type=template&id=4bac4f69&scoped=true&"
import script from "./TheAppHeader.vue?vue&type=script&lang=ts&"
export * from "./TheAppHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TheAppHeader.vue?vue&type=style&index=0&id=4bac4f69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bac4f69",
  null
  
)

export default component.exports